
import { useState } from 'react';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showStats, setShowStats] = useState(false);

  const handleSearch = () => {
    if (searchQuery.trim()) {
      setShowStats(true);
    }
  };

  return (
    <section className="relative min-h-screen bg-white flex items-center justify-center overflow-hidden pt-8">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-400/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center -mt-20">
        {/* Logo */}
        <div className="mb-6 animate-fadeIn">
          <div className="w-40 h-40 mx-auto mb-4 flex items-center justify-center">
            <img 
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/285b7640542be24b8fdcf99e084fae95.png" 
              alt="شعار المؤسسة" 
              className="w-full h-full object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500"
            />
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight animate-slideUp" style={{ fontFamily: 'Cairo, sans-serif' }}>
          إدارة حسابات التواصل الاجتماعي
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-blue-600 mt-2 pb-2">
            باحترافية
          </span>
        </h1>

        {/* Search Bar */}
        <div className="max-w-3xl mx-auto mb-8 animate-slideUp" style={{ animationDelay: '0.4s' }}>
          <div className="relative">
            <div className="flex items-stretch bg-gray-50 rounded-full shadow-lg overflow-hidden border-2 border-gray-200 hover:border-yellow-400 transition-all duration-300">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                placeholder="ابحث عن اسم مشهور..."
                className="flex-1 px-8 py-6 text-lg text-gray-900 bg-transparent outline-none"
                style={{ fontFamily: 'Cairo, sans-serif' }}
              />
              <button
                onClick={handleSearch}
                className="px-10 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 hover:from-yellow-500 hover:to-yellow-600 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap"
              >
                <i className="ri-search-line text-2xl"></i>
                <span className="font-semibold text-lg" style={{ fontFamily: 'Cairo, sans-serif' }}>بحث</span>
              </button>
            </div>
          </div>

          {/* Stats Card */}
          {showStats && (
            <div className="mt-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8 shadow-xl border border-gray-200 animate-fadeIn">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center p-6 bg-white rounded-2xl hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-100">
                  <div className="text-4xl font-bold text-yellow-500 mb-2">2.5M</div>
                  <div className="text-gray-700 text-sm" style={{ fontFamily: 'Cairo, sans-serif' }}>عدد المتابعين</div>
                </div>
                <div className="text-center p-6 bg-white rounded-2xl hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-100">
                  <div className="text-4xl font-bold text-yellow-500 mb-2">8.7%</div>
                  <div className="text-gray-700 text-sm" style={{ fontFamily: 'Cairo, sans-serif' }}>معدل التفاعل</div>
                </div>
                <div className="text-center p-6 bg-white rounded-2xl hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-100">
                  <div className="text-4xl font-bold text-yellow-500 mb-2">#127</div>
                  <div className="text-gray-700 text-sm" style={{ fontFamily: 'Cairo, sans-serif' }}>ترتيب الحساب</div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-6">
          <a
            href="https://wa.me/966500000000"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-5 bg-gradient-to-r from-green-500 to-green-600 text-white text-lg font-semibold rounded-full hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap flex items-center gap-3"
            style={{ fontFamily: 'Cairo, sans-serif' }}
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            تواصل الآن
          </a>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 1s ease-out;
          animation-fill-mode: both;
        }
      `}</style>
    </section>
  );
}
